import { render, staticRenderFns } from "./FontSelector.vue?vue&type=template&id=375834ab"
import script from "./FontSelector.vue?vue&type=script&lang=js"
export * from "./FontSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports